import { SeatSelectionRuleName } from '@vista-digital/occ-domain';
import { assertUnreachableHelper } from '../../../utils/assertion-utils';
export function getSeatSelectionRuleViolationErrorMessage(ruleName, selectedSeatCount, displayText) {
    switch (ruleName) {
        case SeatSelectionRuleName.CannotLeaveGapsBetweenSelectedSeats:
            return displayText.errorGapBetweenSelectedSeatsMessage;
        case SeatSelectionRuleName.CannotLeaveSingleSeatGapFromAisle:
            return displayText.errorSingleSeatGapFromAisleMessage;
        case SeatSelectionRuleName.CannotLeaveSingleSeatGapFromUnavailableSeat:
            return displayText.errorSingleSeatGapFromUnavailableSeatMessage;
        case SeatSelectionRuleName.MustFillSofaSeats:
            return displayText.errorEntireSofaNotSelectedMessage;
        case SeatSelectionRuleName.MustSelectAssociatedWheelchairSeat:
            return displayText.errorCompanionSeatNotSelectedMessage;
        case SeatSelectionRuleName.MustRespectSeatSelectionLimits:
            if (selectedSeatCount === 0) {
                return displayText.errorNoSeatsSelectedMessage;
            }
            return displayText.errorNotAllSeatsSelectedMessage;
        default:
            return assertUnreachableHelper('Invalid seat selection rule')(ruleName);
    }
}
//# sourceMappingURL=seat-picker-error-message-mapper.js.map